import { render, staticRenderFns } from "./PerInfo.vue?vue&type=template&id=5cd30b4c&scoped=true&"
import script from "./PerInfo.vue?vue&type=script&lang=js&"
export * from "./PerInfo.vue?vue&type=script&lang=js&"
import style0 from "./PerInfo.vue?vue&type=style&index=0&id=5cd30b4c&prod&lang=less&"
import style1 from "./PerInfo.vue?vue&type=style&index=1&id=5cd30b4c&prod&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd30b4c",
  null
  
)

export default component.exports